import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id A085C7C7-F5C5-441C-84C0-05EB3B6A8767
 * name view-parallel
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-parallel.svg
 * tags
 * - View 
 */
export const ViewParallelIcon = createSvgIcon(<><path d="M19 3V21H15V3H19M14 3V21H10V3H14M9 3V21H5V3H9Z" /></>, 'ViewParallelIcon');
export default ViewParallelIcon